<template>
  <v-flex xs12 class='subscription'>
    E-Komics subscription is not available in your region.
  </v-flex>
</template>

<script>
export default {
  name: 'subscriptionBR',
  data() {
    return {};
  }
};
</script>

<style lang='scss'>
@import '../../assets/css/_variables';
</style>
